<template>
  <el-button
    @click="handleClick"
    :icon="icon"
    :type="type"
    :loading="loading"
    :title="(title ? title : value)"
    :size="size"
    :disabled="disabled"
  >
    <span class="d-none d-sm-inline d-xl-inline">
      {{value}}
    </span>
  </el-button>
</template>

<script>
  export default {
      name:"ed-button",
      components:{},
      mixins:[],
      props:{
        icon:{
          type:String,
          default:function(){
            return ''
          }
        },
        type:{
          type:String,
          default:function(){
            return 'primary'
          }
        },
        size:{
          type:String,
          default:function(){
            return 'medium'
          }
        },
        title:{
          type:String,
          default:function(){
            return ''
          }
        },
        value:{
          type:String,
          default:function(){
            return ''
          }
        },
        loading:{
          type:Boolean,
          default:function(){
            return false
          }
        },
        disabled:{
          type:Boolean,
          default:function(){
            return false
          }
        },
        click:{
          type:Function,
          default:function(){
            return {}
          }
        }
      },
      watch:{
        icon(){
        },
        type(){
        },
        size(){
        },
        title(){
        },
        value(){
        },
        disabled(){
        },
        loading(){
        },
        click(){
        }
      },

      data() {
        return {
        }
      },
      mounted() {
      },
    
      methods:{
        handleClick(evt) {
          this.$emit('click')
        }
        
      }
  }
</script>



// WEBPACK FOOTER //
// button.vue?14e2f9a5